import { gql } from '@apollo/client';
import appraiserAdminFieldsFragment from './appraiserAdminFieldsFragment';

const GET_APPRAISER_INFO = gql`
  query GetAppraiserInfo($externalUserId: Int!) {
    appraiserInfo(externalUserId: $externalUserId) {
      ...AppraiserAdminFields
    }
  }
  ${appraiserAdminFieldsFragment}
`;

export default GET_APPRAISER_INFO;
